import {format, isDate} from 'date-fns';

export const handleDate = (date) => {
  if (date?.length > 0 && isDate(new Date(date))) {
    return format(new Date(date), 'MM/dd/yyyy')
  } else {
    return null;
  }
}
